module.exports = __webpack_public_path__ + "img/11.f59e417f.jpg";